import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function useCompleteBlueprintMutation() {
  return useMutation<{ success: true }, { error: string }, { id: string }>({
    mutationFn: (values) => api.post('/forge/complete', values),
  });
}

export function useManufactureMutation() {
  return useMutation<{ success: true }, { error: string }, { id: string }>({
    mutationFn: (values) => api.post('/forge/manufacture', values),
  });
}